(() => {
  if (customElements.get('al-gift-box')) return;
  const choices = new Map();
  const originalVariantTitles = {"56625142956380":"Pour Elle","56625142989148":"Pour Lui","56625143021916":"Pour le Couple","56634683785564":"2 Paires - Noire et Argent"};
  class GiftBox extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-gift-config]').textContent);
      this.text = JSON.parse(document.getElementById('al-runtime-i18n').textContent);
      const labels = {'Écrin LED inclus': this.text.led_included, 'Écrin LED inclus dans l’offre Premium': this.text.premium_led};
      ['label', 'includedLabel'].forEach(key => { if (labels[this.config[key]]) this.config[key] = labels[this.config[key]]; });
      this.prices = JSON.parse(this.querySelector('[data-gift-prices]')?.textContent || '{}');
      this.initial = JSON.parse(this.querySelector('[data-gift-initial]').textContent);
      this.base = JSON.parse(this.querySelector('[data-gift-base]')?.textContent || 'null');
      this.deliveryNote = this.querySelector('.al-gift-note').textContent;
      this.scope = this.closest('product-info');
      if (!this.scope) return;
      this.fallbackMedia = this.scope.querySelector('media-gallery li.is-active[data-media-id]')?.getAttribute('data-media-id') || this.scope.querySelector('media-gallery li[data-media-id]')?.getAttribute('data-media-id');
      this.chosen = choices.get(this.dataset.product) || false;
      if (this.config.legacyBase) {
        this.setAttribute('data-legacy', '');
        this.chosen ||= this.initial.id !== this.config.legacyBase;
        if (this.initial.id !== this.config.legacyBase) {
          customElements.whenDefined('variant-selects').then(() => {
            const selector = this.scope.querySelector('variant-selects input[value="Sans écrin cadeau"]');
            if (selector && this.isConnected) {
              selector.checked = true;
              selector.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      }
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.chosen = event.target.value === 'yes';
        choices.set(this.dataset.product, this.chosen);
        this.sync(true);
      });
      this.onVariant = () => this.schedule();
      this.scope.addEventListener('change', this.onVariant);
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.scope, { childList: true, subtree: true });
      this.onSubmit = event => this.submit(event);
      document.addEventListener('submit', this.onSubmit, true);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;
          this.lastMedia = null;
          this.sync(this.chosen);
        });
      }
      this.sync();
      customElements.whenDefined('media-gallery').then(() => {
        if (!this.isConnected) return;
        this.lastMedia = null;
        this.sync(this.chosen);
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.onVariant);
      document.removeEventListener('submit', this.onSubmit, true);
      this.unsubscribe?.();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.sync());
    }
    current() {
      if (this.config.legacyBase) return this.base;
      const selected = this.scope.querySelector('variant-selects [data-selected-variant]');
      try { return selected ? JSON.parse(selected.textContent) : this.initial; }
      catch { return null; }
    }
    selection(variant) {
      const title = (originalVariantTitles[String(variant?.id)] || variant?.title || '').toLocaleLowerCase('fr');
      return (this.config.rules || []).find(rule => title.includes(rule.contains.toLocaleLowerCase('fr'))) || this.config;
    }
    sync(showMedia = false) {
      const variant = this.current();
      this.variant = variant;
      const title = (variant?.title || '').toLocaleLowerCase('fr');
      const gift = this.selection(variant);
      const mode = gift.mode || this.config.mode;
      this.included = mode === 'included' || Boolean(this.config.includedContains && title.includes(this.config.includedContains.toLocaleLowerCase('fr')));
      this.gift = gift;
      const box = this.prices[String(gift.variant)];
      const priced = box && Number.isFinite(box.price);
      const excluded = mode === 'excluded' || mode === 'disabled';
      const active = this.chosen && !this.included && !excluded && Boolean(variant) && Boolean(priced);
      const surcharge = this.querySelector('[data-gift-surcharge]');
      const surchargeText = priced ? ' · +' + box.formatted : '';
      if (surcharge && surcharge.textContent !== surchargeText) surcharge.textContent = surchargeText;
      this.querySelector('input[value="yes"]').disabled = !priced || excluded;
      const note = this.querySelector('.al-gift-note');
      const noteText = this.deliveryNote + (gift.photoNote ? ' ' + gift.photoNote : '');
      if (note.textContent !== noteText) note.textContent = noteText;
      this.querySelector('.al-gift-options').hidden = this.included || excluded || !priced;
      this.querySelector('.al-gift-note').hidden = !active;
      this.querySelector('.al-gift-total').hidden = !active;
      this.querySelector('.al-gift-included').hidden = !this.included;
      const includedText = this.config.includedLabel || this.config.label || '';
      const included = this.querySelector('.al-gift-included');
      if (included.textContent !== includedText) included.textContent = includedText;
      this.querySelector('input[value="yes"]').checked = this.chosen;
      this.querySelector('input[value="no"]').checked = !this.chosen;
      if (active) {
        const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format((variant.price + box.price) / 100);
        const total = this.querySelector('.al-gift-total strong');
        if (total.textContent !== money) total.textContent = money;
      }
      if (this.config.legacyBase) {
        const form = document.getElementById('product-form-' + this.dataset.section);
        const input = form?.querySelector('[name="id"]');
        if (input) input.value = String(this.config.legacyBase);
        if (this.initial.id !== this.config.legacyBase && variant?.available) {
          const button = form?.querySelector('[type="submit"]');
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            const text = button.querySelector('span');
            if (text && window.variantStrings) text.textContent = window.variantStrings.addToCart;
          }
        }
      }
      const mediaKey = active ? String(gift.media) + ':' + variant.id : 'base';
      if ((showMedia || (active && !this.lastMedia) || (this.lastMedia && this.lastMedia !== mediaKey)) && mediaKey !== this.lastMedia) {
        const gallery = this.scope.querySelector('media-gallery');
        const media = active ? gift.media : variant?.featured_media?.id || this.initial.featured_media?.id;
        const mediaId = media ? this.dataset.section + '-' + media : this.fallbackMedia;
        let targetMediaId = mediaId;
        if (active && gallery && !gallery.querySelector(`li[data-media-id="${targetMediaId}"]`)) {
          const imageStem = (gift.image || '').split('/').pop().split('?')[0].replace(/\.[^.]+$/, '');
          const matchingSlide = imageStem && Array.from(gallery.querySelectorAll('li[data-media-id]')).find(slide => {
            const fileName = (slide.querySelector('img')?.getAttribute('src') || '').split('/').pop().split('?')[0];
            return fileName === imageStem + '.png' || fileName.startsWith(imageStem + '_') || fileName.replace(/\.[^.]+$/, '') === imageStem;
          });
          targetMediaId = matchingSlide?.getAttribute('data-media-id');
        }
        if (targetMediaId && gallery?.querySelector(`li[data-media-id="${targetMediaId}"]`)) gallery.setActiveMedia?.(targetMediaId, false);
      }
      this.lastMedia = mediaKey;
      this.active = active;
    }
    async submit(event) {
      const form = event.target;
      if (form.getAttribute('id') !== 'product-form-' + this.dataset.section || !this.isConnected) return;
      this.sync();
      if (!this.active) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('[type="submit"]');
      if (this.busy || button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
      this.busy = true;
      const error = this.querySelector('.al-gift-error');
      error.hidden = true;
      button?.setAttribute('aria-disabled', 'true');
      button?.classList.add('loading');
      form.closest('product-form')?.handleErrorMessage?.();
      const spinner = form.querySelector('.loading__spinner');
      spinner?.classList.remove('hidden');
      try {
        const data = new FormData(form);
        const quantity = Number(data.get('quantity') || 1);
        const group = 'gift-' + this.dataset.product + '-' + Date.now();
        const properties = {};
        for (const [key, value] of data) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match) properties[match[1]] = value;
        }
        properties[this.text.presentation] = this.text.gift_presentation;
        properties._gift_group = group;
        const jewelry = { id: Number(this.config.legacyBase || data.get('id')), quantity, properties };
        if (data.get('selling_plan')) jewelry.selling_plan = data.get('selling_plan');
        const items = [jewelry, { id: this.gift.variant, quantity, properties: { [this.text.for_jewellery]: this.dataset.title, _gift_group: group } }];
        const cart = document.querySelector('cart-drawer');
        const body = { items, sections_url: location.pathname };
        if (cart) {
          body.sections = cart.getSectionsToRender().map(section => section.id);
          cart.setActiveElement(document.activeElement);
        }
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message);
        if (cart && result.sections && Object.values(result.sections).every(Boolean)) {
          cart.classList.remove('is-empty');
          cart.renderContents({ ...result, id: jewelry.id });
        } else location.assign(window.Shopify.routes.root + 'cart');
      } catch (failure) {
        if (failure.message) error.textContent = failure.message;
        error.hidden = false;
        error.scrollIntoView({ block: 'nearest' });
      } finally {
        this.busy = false;
        button?.removeAttribute('aria-disabled');
        button?.classList.remove('loading');
        spinner?.classList.add('hidden');
      }
    }
  }
  customElements.define('al-gift-box', GiftBox);
})();

